import { ReactNode, useContext, useState } from "react";
import {
  Box,
  Flex,
  HStack,
  Link,
  IconButton,
  Button,
  useDisclosure,
  useColorModeValue,
  Stack,
  Heading,
  Icon,
  Text,
} from "@chakra-ui/react";
import { HamburgerIcon, CloseIcon } from "@chakra-ui/icons";
import AvatarWithPicture from "./AvatarWithPicture/AvatarWithPicture";
import { AuthenticationService } from "../../../services/AuthenticationService";
import { ContextApp } from "../../../shared/ContextApp";
import { FiUser } from "react-icons/fi";
import ButtonToggleColorMode from "./ButtonToggleColorMode/ButtonToggleColorMode";
import IconFunkoStore from "./assets/f2.png";
import { useCheckAddressForUser } from "../../../services/hooks/useCheckAddressForUser";

const Links = ["Productos", "Colecciones", "Ventas", "Consultas"];
const Path = [
  "/administration",
  "/administration/adminCollections",
  "/administration/sales",
  "/administration/adminConsultation",
];
export interface INavLinkProps {
  path: string;
}
const NavLink = ({
  children,
  props,
}: {
  children: ReactNode;
  props: INavLinkProps;
}) => {
  const { path } = props;
  return (
    <Link
      px={2}
      py={1}
      rounded={"md"}
      _hover={{
        textDecoration: "none",
        bg: useColorModeValue("gray.200", "gray.700"),
      }}
      href={path}
    >
      {children}
    </Link>
  );
};

export default function Simple() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { login } = AuthenticationService();
  const { user } = useContext(ContextApp);
  const [loading, setLoading] = useState(false);
  useCheckAddressForUser();

  const loginUser = async () => {
    setLoading(true);
    await login();
    setLoading(false);
  };

  return (
    <>
      <Box className="navbar">
        <Flex
          shadow={"md"}
          px={4}
          w="100%"
          h={24}
          alignItems={"center"}
          justifyContent={"space-between"}
        >
          <IconButton
            size={"md"}
            icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
            aria-label={"Open Menu"}
            display={{ md: "none" }}
            onClick={isOpen ? onClose : onOpen}
          />
          <HStack spacing={8} alignItems={"center"}>
            <Box>
              <Link className="link-without-underline" href="/">
                <img width={"100px"} height="100px" src={IconFunkoStore} />
              </Link>
            </Box>
            <HStack
              as={"nav"}
              spacing={4}
              display={{ base: "none", md: "flex" }}
            >
              {Links.map((link, index) => (
                <>
                  {link === "Mi carrito" || link === "Mis compras" ? (
                    <>
                      {user ? (
                        <NavLink props={{ path: Path[index] }} key={link}>
                          <Text display={"flex"}>{link}</Text>
                        </NavLink>
                      ) : null}
                    </>
                  ) : (
                    <NavLink props={{ path: Path[index] }} key={link}>
                      <Text display={"flex"}>{link}</Text>
                    </NavLink>
                  )}
                </>
              ))}
            </HStack>
          </HStack>
          <Flex alignItems={"center"}>
            <Box
              style={{ marginRight: "5px" }}
              display={{ base: "none", md: "block" }}
            >
              <ButtonToggleColorMode />
            </Box>
            {!user ? (
              <>
                <Button
                  display={{ base: "none", md: "block" }}
                  isLoading={loading}
                  onClick={() => {
                    loginUser();
                  }}
                >
                  Ingresar
                </Button>
                <IconButton
                  size={"md"}
                  icon={<Icon as={FiUser} />}
                  aria-label={"Login"}
                  display={{ md: "none" }}
                  onClick={() => loginUser()}
                  isLoading={loading}
                />
              </>
            ) : (
              <AvatarWithPicture />
            )}
          </Flex>
        </Flex>

        {isOpen ? (
          <Box px={5} pb={4} display={{ md: "none" }}>
            <Stack as={"nav"} spacing={4}>
              <ButtonToggleColorMode />
              {Links.map((link, index) => (
                <>
                  {link === "Mi carrito" || link === "Mis compras" ? (
                    <>
                      {user ? (
                        <NavLink props={{ path: Path[index] }} key={link}>
                          <Text display={"flex"}>{link}</Text>
                        </NavLink>
                      ) : null}
                    </>
                  ) : (
                    <NavLink props={{ path: Path[index] }} key={link}>
                      <Text display={"flex"}>{link}</Text>
                    </NavLink>
                  )}
                </>
              ))}
            </Stack>
          </Box>
        ) : null}
      </Box>
    </>
  );
}
